export default __webpack_public_path__ + "static/media/NotoSans-Bold.0476118d.otf";